import { and, not, or, Roles } from '@/js/libs/use-auth';

const notPostnetzBranchUser = not(or(Roles.POSTNETZ_BRANCH_USER, Roles.READ_ONLY_POSTNETZ_BRANCH_USER));

export const productCatalogueRouteRoles = and(
  or(
    Roles.POSTNETZ,
    Roles.MANAGE_DIGITAL_PRODUCTS,
    Roles.MANAGE_RADIO_PRODUCTS,
    Roles.MANAGE_TV_PRODUCTS,
    Roles.MANAGE_PRINT_PRODUCTS,
    Roles.MANAGE_POS_PRODUCTS,
    Roles.MANAGE_CONSULTING_PRODUCTS,
  ),
  notPostnetzBranchUser,
);

export const companySettingsRouteRoles = and(
  or(
    and(Roles.REPORT_BUILDER, or(Roles.BOOK_CAMPAIGNS, Roles.SALESFUNNEL, Roles.POSTADMANAGER)),
    Roles.ADMIN,
    Roles.POSTADMANAGER,
    Roles.MANAGE_ACCOUNTS,
    Roles.PAYOUT,
    Roles.BOOK_CAMPAIGNS,
    Roles.MANAGE_CAMPAIGN_TYPES,
  ),
  notPostnetzBranchUser,
);

export const programmaticMappingRouteRoles = and(or(Roles.ADMIN, Roles.PAYOUT), notPostnetzBranchUser);

export const settingsRouteRoles = and(
  or(
    Roles.POSTNETZ,
    // Data Import is the only entry MANAGE_ACCOUNTS opens here, and POSTADMANAGER is denied it
    and(Roles.MANAGE_ACCOUNTS, not(Roles.POSTADMANAGER)),
    Roles.MANAGE_REFERENCE_PER_AD_MEDIA,
    Roles.SPECIAL_DISCOUNTS,
    Roles.CONTRACT,
  ),
  notPostnetzBranchUser,
);
